export const wlPath = path => {
  return `/${ADVISOR_BRAND.url_slug}${path}`;
};
export const wlVar = key => {
  return ADVISOR_BRAND[key];
};
